import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cell-array',
  templateUrl: './cell-array.component.html',
  styleUrls: ['./cell-array.component.scss']
})
export class CellArrayComponent implements OnInit, AfterViewInit {
  @Input('values') public values: any;

  public array: any = []
  constructor() { }

  ngOnInit(): void {
    try {
      this.array = JSON.parse(this.values.value);
    }
    catch(e){
    }

  }

  ngAfterViewInit() {
  }


}
